import React, { Component } from 'react';
import RichText from 'legacy-src/utility/RichText';

import { viewed } from '../shared/status';

class Player extends Component {
  render() {
    const { text } = this.props.item.content;
    return (
      <RichText content={text} extra={{ 'data-am-type': 'media/rich_text' }} />
    );
  }
}

Player.displayName = 'RichText';

export default { Player, status: viewed };
